var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 8.33333H5.83335C7.50002 8.33333 8.33335 7.5 8.33335 5.83333V4.16667C8.33335 2.5 7.50002 1.66667 5.83335 1.66667H4.16669C2.50002 1.66667 1.66669 2.5 1.66669 4.16667V5.83333C1.66669 7.5 2.50002 8.33333 4.16669 8.33333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33333H15.8334C17.5 8.33333 18.3334 7.5 18.3334 5.83333V4.16667C18.3334 2.5 17.5 1.66667 15.8334 1.66667H14.1667C12.5 1.66667 11.6667 2.5 11.6667 4.16667V5.83333C11.6667 7.5 12.5 8.33333 14.1667 8.33333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333H15.8334C17.5 18.3333 18.3334 17.5 18.3334 15.8333V14.1667C18.3334 12.5 17.5 11.6667 15.8334 11.6667H14.1667C12.5 11.6667 11.6667 12.5 11.6667 14.1667V15.8333C11.6667 17.5 12.5 18.3333 14.1667 18.3333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 18.3333H5.83335C7.50002 18.3333 8.33335 17.5 8.33335 15.8333V14.1667C8.33335 12.5 7.50002 11.6667 5.83335 11.6667H4.16669C2.50002 11.6667 1.66669 12.5 1.66669 14.1667V15.8333C1.66669 17.5 2.50002 18.3333 4.16669 18.3333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.ebc776ad37ebce2e541ba62200b343f2.svg";
export { ForwardRef as ReactComponent };